import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    userSettings: {},
    chartSliderMode: {
      data: {
        track: false,
        interval: false,
        picker: false
      },
      component: null
    },
    selectedTime: {
      data: null,
      component: null
    },
    selectedInterval: {
      tracks: [],
      startTime: null,
      endTime: null,
      component: null
    },
    selectedRequestsIds: {
      data: [],
      component: null
    },
    selectedRequestsAlarmsIds: {
      data: [],
      component: null,
      changeClickedMarker: true
    },
    selectedReportsRequestIds: {
      data: [],
      component: null
    },
    selectedHeatmapReportsRequestIds: {
      data: [],
      component: null
    },
    selectedServiceObjectsIds: {
      data: [],
      component: null
    },
    selectedVehiclesIds: {
      data: [],
      component: null
    },
    selectedAssignmentsIds: {
      data: [],
      component: null
    },
    selectedAssignmentsAlarmsIds: {
      data: [],
      component: null,
      changeClickedMarker: true
    },
    assignmentRequestIds: [],

    indicators: [],

    requestTypes: [],
    requestDeliveryVISes: [],
    requestSources: [],
    priorityConditions: [],
    workTypes: [],
    workShifts: [],
    selectedWorkAreas: [],
    workAreas: [],

    roles: [],

    projects: [],

    systemConfig: {},
    systemTreesRoots: {},

    taskLoading: {
      active: false,
      actionType: null,
      actionName: null
    },
    taskStatesColors: [],
    requestTypesColors: [],
    requestTypesTextColors: [],
    requestPopupTab: null,

    columnWidths: {},
    changeWidthTimerID: {},

    requestsFilterUpdatedSwitch: false,
    serviceObjectsFilterUpdatedSwitch: false,
    brigadesFilterUpdatedSwitch: false,

    brigadeId: null,
    documentScrollTop: null,
    dispatcherTableScrollTop: null,

    currentDocumentValidationErrors: 0,

    currentDocumentLabel: null,

    reportStateColors: null,
    reportStateTextColors: null,

    selectedRequestPopup: {},

    selectedSystemReport: {},
    pingResult: {},
    countAddSK3: {},
    countTransferSK3: {},

    vehicleProvisionIndicators: {},

    invcometRequest: {},

    imageViewerOptions: {},

    actualityWindowFullScreen: false,

    hasFaulties: false
  },
  getters: {
    getBrigadeId: state => state.brigadeId,
    getDocumentScrollTop: state => state.documentScrollTop,
    getDispatcherTableScrollTop: state => state.dispatcherTableScrollTop,
    getCurrentDocumentValidationErrors: state => state.currentDocumentValidationErrors,
    getCurrentDocumentLabel: state => state.currentDocumentLabel,
    getUser: state => state.user,
    getUserSettings: state => state.userSettings,
    getUserSetting: state => (key, defaultValue) => {
      const value = state.userSettings[key]
      return value != null ? value : defaultValue
    },
    getChartSliderMode: state => state.chartSliderMode,
    getSelectedTime: state => state.selectedTime,
    getSelectedInterval: state => state.selectedInterval,
    getSelectedRequestsIds: state => state.selectedRequestsIds,
    getSelectedRequestsAlarmsIds: state => state.selectedRequestsAlarmsIds,
    getSelectedReportsRequestIds: state => state.selectedReportsRequestIds,
    getSelectedHeatmapReportsRequestIds: state => state.selectedHeatmapReportsRequestIds,
    getSelectedServiceObjectsIds: state => state.selectedServiceObjectsIds,
    getSelectedVehiclesIds: state => state.selectedVehiclesIds,
    getSelectedAssignmentsIds: state => state.selectedAssignmentsIds,
    getSelectedAssignmentsAlarmsIds: state => state.selectedAssignmentsAlarmsIds,
    getAssignmentRequestIds: state => state.assignmentRequestIds,
    getIndicators: state => state.indicators,
    getRequestTypes: state => state.requestTypes,
    getRequestDeliveryVISes: state => state.requestDeliveryVISes,
    getRequestSources: state => state.requestSources,
    getRequestPriorityConditions: state => state.priorityConditions,
    getWorkTypes: state => state.workTypes,
    getWorkShifts: state => state.workShifts,
    getCustomWorkShiftColor: state => state.customWorkShiftColor,
    getCustomWorkShiftFontColor: state => state.customWorkShiftFontColor,
    getSelectedWorkAreas: state => state.selectedWorkAreas,
    getWorkAreas: state => state.workAreas,
    getRoles: state => state.roles,
    getStocks: state => state.stocks,
    getSystemConfig: state => state.systemConfig,
    getSystemNodeTypeConfig: state => typeKey => {
      if (state.systemConfig.nodes) {
        return state.systemConfig.nodes[typeKey]
      } else {
        return null
      }
    },
    getSystemTreesRoots: state => state.systemTreesRoots,
    getSystemTreeRoot: state => name => {
      return state.systemTreesRoots[name]
    },
    getTaskLoading: state => state.taskLoading,
    getTaskStatesColors: state => state.taskStatesColors,
    getRequestTypesColors: state => state.requestTypesColors,
    getRequestTypesTextColors: state => state.requestTypesTextColors,
    getRequestPopupTab: state => state.requestPopupTab,

    getColumnWidths: state => state.columnWidths,
    getChangeWidthTimerID: state => tableName => {
      if (state.changeWidthTimerID) {
        return state.changeWidthTimerID[tableName]
      } else {
        return null
      }
    },

    getRequestsFilterUpdatedSwitch: state => state.requestsFilterUpdatedSwitch,
    getServiceObjectsFilterUpdatedSwitch: state => state.serviceObjectsFilterUpdatedSwitch,
    getBrigadesFilterUpdatedSwitch: state => state.brigadesFilterUpdatedSwitch,
    getReportStateColors: state => state.reportStateColors,
    getReportStateTextColors: state => state.reportStateTextColors,
    getSelectedRequestPopup: state => state.selectedRequestPopup,
    getSelectedSystemReport: state => state.selectedSystemReport,

    getPingResult: state => state.pingResult,
    getCountAddSK3: state => state.countAddSK3,
    getCountTransferSK3: state => state.countTransferSK3,

    getVehicleProvisionIndicators: state => state.vehicleProvisionIndicators,

    getInvcometRequest: state => state.invcometRequest,

    getImageViewerOptions: state => state.imageViewerOptions,
    getActualityWindowFullScreen: state => state.actualityWindowFullScreen,
    getHasFaulties: state => state.hasFaulties
  },
  actions: {
    setBrigadeId (context, payload) {
      context.commit('setBrigadeId', payload)
    },
    setDocumentScrollTop (context, payload) {
      context.commit('setDocumentScrollTop', payload)
    },
    setDispatcherTableScrollTop (context, payload) {
      context.commit('setDispatcherTableScrollTop', payload)
    },
    setCurrentDocumentValidationErrors (context, payload) {
      context.commit('setCurrentDocumentValidationErrors', payload)
    },
    setCurrentDocumentLabel (context, payload) {
      context.commit('setCurrentDocumentLabel', payload)
    },
    setUser (context, payload) {
      context.commit('setUser', payload)
    },
    setChartSliderMode (context, payload) {
      context.commit('setChartSliderMode', payload)
    },
    setSelectedTime (context, payload) {
      context.commit('setSelectedTime', payload)
    },
    setSelectedInterval (context, payload) {
      context.commit('setSelectedInterval', payload)
    },
    setSelectedRequestsIds (context, payload) {
      context.commit('setSelectedRequestsIds', payload)
    },
    setSelectedRequestsAlarmsIds (context, payload) {
      context.commit('setSelectedRequestsAlarmsIds', payload)
    },
    setSelectedReportsRequestIds (context, payload) {
      context.commit('setSelectedReportsRequestIds', payload)
    },
    setSelectedHeatmapReportsRequestIds (context, payload) {
      context.commit('setSelectedHeatmapReportsRequestIds', payload)
    },
    setSelectedServiceObjectsIds (context, payload) {
      context.commit('setSelectedServiceObjectsIds', payload)
    },
    setSelectedVehiclesIds (context, payload) {
      context.commit('setSelectedVehiclesIds', payload)
    },
    setSelectedAssignmentsIds (context, payload) {
      context.commit('setSelectedAssignmentsIds', payload)
    },
    setSelectedAssignmentsAlarmsIds (context, payload) {
      context.commit('setSelectedAssignmentsAlarmsIds', payload)
    },
    setAssignmentRequestIds (context, payload) {
      context.commit('setAssignmentRequestIds', payload)
    },
    setIndicators (context, payload) {
      context.commit('setIndicators', payload)
    },
    setRequestTypes (context, payload) {
      context.commit('setRequestTypes', payload)
    },
    setRequestDeliveryVISes (context, payload) {
      context.commit('setRequestDeliveryVISes', payload)
    },
    setRequestSources (context, payload) {
      context.commit('setRequestSources', payload)
    },
    setRequestPriorityConditions (context, payload) {
      context.commit('setRequestPriorityConditions', payload)
    },
    setWorkTypes (context, payload) {
      context.commit('setWorkTypes', payload)
    },
    setWorkShifts (context, payload) {
      context.commit('setWorkShifts', payload)
    },
    setWorkShiftsColors (context, payload) {
      context.commit('setWorkShiftsColors', payload)
    },
    setWorkShiftsFontColors (context, payload) {
      context.commit('setWorkShiftsFontColors', payload)
    },
    setCustomWorkShiftColor (context, payload) {
      context.commit('setCustomWorkShiftColor', payload)
    },
    setCustomWorkShiftFontColor (context, payload) {
      context.commit('setCustomWorkShiftFontColor', payload)
    },
    setSelectedWorkAreas (context, payload) {
      context.commit('setSelectedWorkAreas', payload)
    },
    setWorkAreas (context, payload) {
      context.commit('setWorkAreas', payload)
    },
    setRoles (context, payload) {
      context.commit('setRoles', payload)
    },
    setStocks (context, payload) {
      context.commit('setStocks', payload)
    },
    setSystemTreesRoots (context, payload) {
      context.commit('setSystemTreesRoots', payload)
    },
    setSystemConfig (context, payload) {
      context.commit('setSystemConfig', payload)
    },
    setTaskLoading (context, payload) {
      context.commit('setTaskLoading', payload)
    },
    setTaskStatesColors (context, payload) {
      context.commit('setTaskStatesColors', payload)
    },
    setRequestTypesColors (context, payload) {
      context.commit('setRequestTypesColors', payload)
    },
    setRequestTypesTextColors (context, payload) {
      context.commit('setRequestTypesTextColors', payload)
    },
    setRequestPopupTab (context, payload) {
      context.commit('setRequestPopupTab', payload)
    },
    setRequestsFilterUpdatedSwitch (context, payload) {
      context.commit('setRequestsFilterUpdatedSwitch', payload)
    },
    setServiceObjectsFilterUpdatedSwitch (context, payload) {
      context.commit('setServiceObjectsFilterUpdatedSwitch', payload)
    },
    setBrigadesFilterUpdatedSwitch (context, payload) {
      context.commit('setBrigadesFilterUpdatedSwitch', payload)
    },
    setReportStateColors (context, payload) {
      context.commit('setReportStateColors', payload)
    },
    setReportStateTextColors (context, payload) {
      context.commit('setReportStateTextColors', payload)
    },
    setColumnWidths (context, payload) {
      context.commit('setColumnWidths', payload)
    },
    setChangeWidthTimerID (context, payload) {
      context.commit('setChangeWidthTimerID', payload)
    },
    setSelectedRequestPopup (context, payload) {
      context.commit('setSelectedRequestPopup', payload)
    },
    setSelectedSystemReport (context, payload) {
      context.commit('setSelectedSystemReport', payload)
    },
    setPingResult (context, payload) {
      context.commit('setPingResult', payload)
    },
    setCountAddSK3 (context, payload) {
      context.commit('setCountAddSK3', payload)
    },
    setCountTransferSK3 (context, payload) {
      context.commit('setCountTransferSK3', payload)
    },
    setVehicleProvisionIndicators (context, payload) {
      context.commit('setVehicleProvisionIndicators', payload)
    },
    setInvcometRequest (context, payload) {
      context.commit('setInvcometRequest', payload)
    },
    setImageViewerOptions (context, payload) {
      context.commit('setImageViewerOptions', payload)
    },
    setActualityWindowFullScreen (context, payload) {
      context.commit('setActualityWindowFullScreen', payload)
    },
    setHasFaulties (context, payload) {
      context.commit('setHasFaulties', payload)
    }
  },
  mutations: {
    setBrigadeId (state, payload) {
      state.brigadeId = payload
    },
    setDocumentScrollTop (state, payload) {
      state.documentScrollTop = payload
    },
    setDispatcherTableScrollTop (state, payload) {
      state.dispatcherTableScrollTop = payload
    },
    setCurrentDocumentValidationErrors (state, payload) {
      state.currentDocumentValidationErrors = payload
    },
    setCurrentDocumentLabel (state, payload) {
      state.currentDocumentLabel = payload
    },
    setUser (state, payload) {
      state.user = payload
      if (payload && payload.settings) {
        state.userSettings = payload.settings
      } else {
        state.userSettings = {}
      }
    },
    setChartSliderMode (state, payload) {
      Vue.set(state, 'chartSliderMode', payload)
    },
    setSelectedTime (state, payload) {
      Vue.set(state, 'selectedTime', payload)
    },
    setSelectedInterval (state, payload) {
      Vue.set(state, 'selectedInterval', payload)
    },
    setSelectedRequestsIds (state, payload) {
      Vue.set(state, 'selectedRequestsIds', {
        data: [...payload.data],
        component: payload.component
      })
    },
    setSelectedRequestsAlarmsIds (state, payload) {
      Vue.set(state, 'selectedRequestsAlarmsIds', {
        data: [...payload.data],
        component: payload.component,
        changeClickedMarker: !!payload.changeClickedMarker
      })
    },
    setSelectedReportsRequestIds (state, payload) {
      Vue.set(state, 'selectedReportsRequestIds', {
        data: [...payload.data],
        component: payload.component
      })
    },
    setSelectedHeatmapReportsRequestIds (state, payload) {
      Vue.set(state, 'selectedHeatmapReportsRequestIds', {
        data: [...payload.data],
        component: payload.component
      })
    },
    setSelectedServiceObjectsIds (state, payload) {
      Vue.set(state, 'selectedServiceObjectsIds', {
        data: [...payload.data],
        component: payload.component
      })
    },
    setSelectedVehiclesIds (state, payload) {
      Vue.set(state, 'selectedVehiclesIds', {
        data: [...payload.data],
        component: payload.component
      })
    },
    setSelectedAssignmentsIds (state, payload) {
      Vue.set(state, 'selectedAssignmentsIds', {
        data: [...payload.data],
        component: payload.component
      })
    },
    setSelectedAssignmentsAlarmsIds (state, payload) {
      Vue.set(state, 'selectedAssignmentsAlarmsIds', {
        data: [...payload.data],
        component: payload.component,
        changeClickedMarker: !!payload.changeClickedMarker
      })
    },
    setAssignmentRequestIds (state, payload) {
      Vue.set(state, 'assignmentRequestIds', [...payload])
    },
    setIndicators (state, payload) {
      state.indicators = payload
    },
    setRequestTypes (state, payload) {
      Vue.set(state, 'requestTypes', [...payload])
    },
    setRequestDeliveryVISes (state, payload) {
      Vue.set(state, 'requestDeliveryVISes', [...payload])
    },
    setRequestSources (state, payload) {
      Vue.set(state, 'requestSources', [...payload])
    },
    setRequestPriorityConditions (state, payload) {
      Vue.set(state, 'priorityConditions', [...payload])
    },
    setWorkTypes (state, payload) {
      Vue.set(state, 'workTypes', [...payload])
    },
    setWorkShifts (state, payload) {
      Vue.set(state, 'workShifts', [...payload])
    },
    setWorkShiftsColors (state, payload) {
      state.workShifts.forEach(workShift => {
        Vue.set(workShift, 'color', payload[workShift.key])
      })
    },
    setCustomWorkShiftColor (state, payload) {
      Vue.set(state, 'customWorkShiftColor', payload)
    },
    setWorkShiftsFontColors (state, payload) {
      state.workShifts.forEach(workShift => {
        Vue.set(workShift, 'fontColor', payload['font.' + workShift.key])
      })
    },
    setCustomWorkShiftFontColor (state, payload) {
      Vue.set(state, 'customWorkShiftFontColor', payload)
    },
    setSelectedWorkAreas (state, payload) {
      Vue.set(state, 'selectedWorkAreas', [...payload])
    },
    setWorkAreas (state, payload) {
      Vue.set(state, 'workAreas', [...payload])
    },
    setRoles (state, payload) {
      Vue.set(state, 'roles', [...payload.map(role => {
        return {
          name: role.name,
          value: role.key,
          editable: role.editable
        }
      })])
    },
    setStocks (state, payload) {
      Vue.set(state, 'stocks', [...payload])
    },
    setSystemTreesRoots (state, payload) {
      state.systemTreesRoots = payload
    },
    setSystemConfig (state, payload) {
      state.systemConfig = payload
    },
    setSelectedRequestPopup (state, payload) {
      state.selectedRequestPopup = payload
    },
    setSelectedSystemReport (state, payload) {
      state.selectedSystemReport = payload
    },
    setTaskLoading (state, payload) {
      if (!payload) {
        payload = {
          active: false,
          actionType: null,
          actionName: null
        }
      }
      state.taskLoading = payload

      // Vue.set(state, 'taskLoading', {
      //   active: !!payload.active,
      //   actionType: payload.actionType,
      //   actionName: payload.actionName
      // })
    },
    setTaskStatesColors (state, payload) {
      state.taskStatesColors = payload
    },
    setRequestTypesColors (state, payload) {
      state.requestTypesColors = payload
    },
    setRequestTypesTextColors (state, payload) {
      state.requestTypesTextColors = payload
    },
    setRequestPopupTab (state, payload) {
      state.requestPopupTab = payload
    },
    setRequestsFilterUpdatedSwitch (state, payload) {
      state.requestsFilterUpdatedSwitch = payload
    },
    setServiceObjectsFilterUpdatedSwitch (state, payload) {
      state.serviceObjectsFilterUpdatedSwitch = payload
    },
    setBrigadesFilterUpdatedSwitch (state, payload) {
      state.brigadesFilterUpdatedSwitch = payload
    },
    setReportStateColors (state, payload) {
      Vue.set(state, 'reportStateColors', payload)
    },
    setReportStateTextColors (state, payload) {
      Vue.set(state, 'reportStateTextColors', payload)
    },
    setColumnWidths (state, payload) {
      Object.entries(payload).forEach(([tableName, tableColumnsWidths]) => {
        const tableColumnsNames = Object.keys(tableColumnsWidths)
        if (tableColumnsNames.length === 0) {
          state.columnWidths[tableName] = {}
        } else {
          if (state.columnWidths[tableName] == null) {
            state.columnWidths[tableName] = tableColumnsWidths
          } else {
            for (let i = 0; i < tableColumnsNames.length; i++) {
              const columnName = tableColumnsNames[i]
              state.columnWidths[tableName][columnName] = tableColumnsWidths[columnName]
            }
          }
        }
      })
    },
    setChangeWidthTimerID (state, payload) {
      Object.entries(payload).forEach(([tableName, tableUpdateFn]) => {
        state.changeWidthTimerID[tableName] = tableUpdateFn
      })
    },
    setPingResult (state, payload) {
      state.pingResult = payload
    },
    setCountAddSK3 (state, payload) {
      state.countAddSK3 = payload
    },
    setCountTransferSK3 (state, payload) {
      state.countTransferSK3 = payload
    },
    setVehicleProvisionIndicators (state, payload) {
      state.vehicleProvisionIndicators = payload
    },
    setInvcometRequest (state, payload) {
      state.invcometRequest = payload
    },
    setImageViewerOptions (state, payload) {
      state.imageViewerOptions = payload
    },
    setActualityWindowFullScreen (state, payload) {
      state.actualityWindowFullScreen = payload
    },
    setHasFaulties (state, payload) {
      state.hasFaulties = payload
    }
  }
})
